import type { QueryClient } from '@tanstack/react-query';

import { getCodingListsEntriesQuery, getCodingListsQuery } from '../../../queries/codingQuery';
import { selectedTeamIdQuery, teamQuery, teamsQuery } from '../../../queries/teamQuery';
import { userQuery } from '../../../queries/userQuery';
export const teamsCodingLoader = async ({ queryClient }: { queryClient: QueryClient }) => {
	await queryClient.ensureQueryData(userQuery);

	const teamIdQuery = selectedTeamIdQuery('selectedTeamID');

	const teamId = await queryClient.ensureQueryData(teamIdQuery);
	const codingLists = await queryClient.ensureQueryData(getCodingListsQuery({ skipDisabled: true }));
	const codingEntries = await queryClient.ensureQueryData(
		getCodingListsEntriesQuery({
			codingLists,
		}),
	);

	return {
		teamId,
		codingLists,
		codingEntries,
		team: await queryClient.ensureQueryData(teamQuery({ teamId: teamId?.[0] || '' })),
		teams: await queryClient.ensureQueryData(teamsQuery({ state: 'active' })),
	};
};
